export default [
  {
    path: '/admin/whole-sales',
    name: 'wholesale',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/index.vue')
  },
  {
    path: '/admin/whole-sales/create',
    name: 'wholesale-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/create.vue')
  },
  {
    path: '/admin/whole-sales/:id/edit',
    name: 'wholesale-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/edit.vue')
  },
  {
    path: '/admin/whole-sales/create-v3',
    name: 'wholesale-create-v3',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/create-v3.vue')
  }
]
